//#region PrimeNg '@primeuix/utils';

const isDate = (value: unknown) => {
  return Object.prototype.toString.call(value) === '[object Date]';
};

const isEmpty = (value: unknown) => {
  return (
    value === null ||
    value === undefined ||
    value === '' ||
    (Array.isArray(value) && value.length === 0) ||
    (!isDate(value) && typeof value === 'object' && Object.keys(value).length === 0)
  );
};

const isNotEmpty = (value: unknown) => {
  return !isEmpty(value);
};

export const isPrintableCharacter = (char = '') => {
  return isNotEmpty(char) && char.length === 1 && char.match(/\S| /);
};

//#region
